import "./ReferenceScoreRange.css";

const ReferenceScoreRange = () => {
  return (
    <div className="flex-box">
      <div>
        <p className="text marg">Referencias:</p>
      </div>
      <div className="flex-number">
        <div className="flex-box-number-text">
          <p className="green-box-number">1</p>
          <p className="text">Bajo</p>
        </div>
        <div className="flex-box-number-text">
          <p className="yellow-box-number">2</p>
          <p className="text">Medio-Bajo</p>
        </div>
        <div className="flex-box-number-text">
          <p className="orange-box-number">3</p>
          <p className="text">Medio</p>
        </div>
        <div className="flex-box-number-text">
          <p className="pínki-box-number">4</p>
          <p className="text">Medio-Alto</p>
        </div>
        <div className="flex-box-number-text">
          <p className="red-box-number">5</p>
          <p className="text">Alto</p>
        </div>
      </div>
    </div>
  );
};

export default ReferenceScoreRange;